import {
  Scoreboard,
  ScoreboardParticipant,
  ScoreboardParticipants,
  ScoreboardScore,
  ScoreboardScores
} from '@ps/isp-web-component-library';
import type { EnrichedParticipants } from '@ps/isp-web-services-types';
import type { VolleyballFixture } from '@ps/web-shared-generated-graphql/sports';
import React from 'react';

import { EventTypeId } from '@swf/sports/types/eventType';
import { getScoreCharacterLength } from '@swf/sports/utils/getScoreCharacterLength';
import { getVolleyballMatchScore } from '@swf/sports/utils/getVolleyballMatchScore';

interface Props {
  enrichedParticipants?: EnrichedParticipants;
  fixture?: VolleyballFixture;
}

interface MatchScore {
  home: number;
  away: number;
}

const getParticipantScore = (
  participant: EnrichedParticipants[number],
  score: MatchScore | undefined
) => (participant.type === 'HOME' ? score?.home : score?.away);

const VolleyballScoreboard = ({ enrichedParticipants, fixture }: Props) => {
  const [participantA, participantB] = enrichedParticipants ?? [];
  const currentSet = fixture?.currentSet;
  const matchScore = getVolleyballMatchScore(fixture?.previousSets);
  const currentServingParticipant = currentSet?.currentServer;

  return (
    <Scoreboard variant="lite">
      <ScoreboardParticipants>
        <ScoreboardParticipant
          name={participantA.participant}
          hasReservedMarkerSpace
          isVisibleMarker={currentServingParticipant === participantA.type}
        />
        <ScoreboardParticipant
          name={participantB.participant}
          hasReservedMarkerSpace
          isVisibleMarker={currentServingParticipant === participantB.type}
        />
      </ScoreboardParticipants>
      <ScoreboardScores>
        <ScoreboardScore
          score={[
            getParticipantScore(participantA, matchScore) ?? null,
            getParticipantScore(participantB, matchScore) ?? null
          ]}
        />
        <ScoreboardScore
          score={[
            getParticipantScore(participantA, currentSet?.score) ?? null,
            getParticipantScore(participantB, currentSet?.score) ?? null
          ]}
          scoreCharacterLength={getScoreCharacterLength(EventTypeId.VOLLEYBALL, [
            currentSet?.score.home ?? 0,
            currentSet?.score.away ?? 0
          ])}
        />
      </ScoreboardScores>
    </Scoreboard>
  );
};

export default VolleyballScoreboard;
